export var Mode;

(function (Mode) {
  Mode["VIEW"] = "view";
  Mode["EDIT"] = "edit";
  Mode["PREVIEW"] = "preview";
})(Mode || (Mode = {}));

export var TableActionType;

(function (TableActionType) {
  TableActionType["SET_MODE"] = "SET_MODE";
  TableActionType["UPDATE_CELL"] = "UPDATE_CELL";
  TableActionType["BULK_UPDATE"] = "BULK_UPDATE";
  TableActionType["SET_SELECTION"] = "SET_SELECTION";
  TableActionType["RESET_DATA"] = "RESET_DATA";
  TableActionType["SET_PAGE"] = "SET_PAGE";
  TableActionType["SET_SORTING"] = "SET_SORTING";
  TableActionType["SET_COLUMN_FILTERS"] = "SET_COLUMN_FILTERS";
  TableActionType["ON_SAVING"] = "ON_SAVING";
  TableActionType["ON_SAVED"] = "ON_SAVED";
  TableActionType["RESET"] = "RESET";
})(TableActionType || (TableActionType = {}));

export var TableColor;

(function (TableColor) {
  TableColor["bg_default"] = "white";
  TableColor["bg_hovered"] = "orange.50";
  TableColor["bg_row_selected"] = "orange.50";
  TableColor["bg_disabled"] = "gray.200";
  TableColor["bg_cell_changed"] = "orange.100";
  TableColor["bg_cell_changed_preview"] = "red.100";
  TableColor["border"] = "gray.100";
  TableColor["text_default"] = "blackAlpha.300";
  TableColor["text_disabled"] = "#A2A2A2";
})(TableColor || (TableColor = {}));